import { psi, scc } from '@schibsted/sourcepoint'
import Tracker from '@spt-tracking/pulse-sdk'

const getUserId = () => {
  const session = sessionStorage.getItem('hasSession-cache')
  const userId = JSON.parse(session)?.value?.userId

  if (!userId) {
    return undefined
  }
  return userId.toString()
}

const getActor = (config) => ({ realm: config.realm, userId: getUserId() })

/**
 *@param {object} config
 * Docs: https://github.schibsted.io/spt-privacy/sourcepoint
 */
export const renderPrivacyModal = (config) => {
  const sdkConfig = { xandrEnabled: false }
  const builders = { actor: Promise.resolve(getActor(config)) }
  const pulse = new Tracker(config.pulseProviderId, sdkConfig, builders)

  const { topLevelDomain } = config
  const sourcepointFunction = topLevelDomain.toLowerCase() === 'se' ? scc : psi

  sourcepointFunction(window, document, navigator, {
    propertyId: config.propertyId,
    consentLanguage: config.consentLanguage,
    baseEndpoint: config.baseEndpoint,
    groupPmId: config.groupPmId,
    accountId: 1047,
    propertyHref: config.propertyHref,
    userId: config.userId,
    realm: config.realm,
    clientId: config.clientId,
    pulseTracker: pulse,
    joinHref: true,
  })
}
